<template>
  <div class="flex items-center">
    <input
      :id="id"
      type="checkbox"
      :checked="modelValue"
      class="h-4 w-4 text-primary-600 focus:ring-primary-500 border-neutral-300 rounded-sm cursor-pointer"
      @change="handleChange"
    >
    <label
      v-if="label"
      :for="id"
      class="ml-2 block text-sm text-neutral-700 cursor-pointer"
    >
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

defineProps<{
  modelValue: boolean
  label?: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
}>()

const id = computed(() => `checkbox-${Math.random().toString(36).substr(2, 9)}`)

const handleChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit('update:modelValue', target.checked)
}
</script> 